// import React from "react";
import "./BlackberryShowcase.scss";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

const showcaseImageData = [
  {
    id: 1,
    img: "/assets/img/elnora/19.png",
  },
  {
    id: 2,
    img: "/assets/img/elnora/23.png",
  },
  {
    id: 3,
    img: "/assets/img/elnora/25.png",
  },
  {
    id: 4,
    img: "/assets/img/elnora/31.png",
  },
  {
    id: 5,
    img: "/assets/img/elnora/28.png",
  },
  {
    id: 6,
    img: "/assets/img/elnora/33.png",
  },
];

const socialMediaLinks = [
  { id: 1, name: "Instagram", icon: <FaInstagram />, url: "#" },
  { id: 2, name: "Facebook", icon: <FaFacebookF />, url: "#" },
  { id: 3, name: "Twitter", icon: <FaTwitter />, url: "#" },
  { id: 4, name: "LinkedIn", icon: <FaLinkedinIn />, url: "#" },
];

const BlackberryShowcase = () => {
  return (
    <div className="bb-showcase">
      <div className="bb-showcase__container">
        <div className="bb-showcase__content">
          <div className="bb-showcase__text-column">
            <h4 className="bb-showcase__subtitle">OUR SHOWCASE</h4>
            <h2 className="bb-showcase__title">Follow Our Journey</h2>
            <p className="bb-showcase__description">
              Discover the latest trends, behind-the-scenes moments, and
              exclusive content. Join our community and stay connected with
              Blackberrys.
            </p>
            <div className="bb-showcase__social">
              <h3 className="bb-showcase__social-title">Follow Us</h3>
              <div className="bb-showcase__social-links">
                {socialMediaLinks.map((social) => (
                  <a
                    key={social.id}
                    href={social.url}
                    className="bb-showcase__social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="bb-showcase__gallery">
            {showcaseImageData.map((item) => (
              <div key={item.id} className="bb-showcase__image-wrapper">
                <img
                  src={item.img}
                  alt={`Showcase ${item.id}`}
                  className="bb-showcase__image"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlackberryShowcase;
